import FadeIn from '../components/FadeIn';

function Pricing() {
    return (
      <>
        <title>vidi3D Pricing - Virtual Tour & 3D Visualization Packages</title>
        <meta name="description" content="Choose from flexible pricing packages for vidi3D's virtual tour and 3D visualization solutions. Scale your sales with immersive technology tailored to your needs." />
        <meta name="keywords" content="3D visualization pricing, virtual tour packages, venue visualization cost, event space technology pricing" />
        <meta property="og:title" content="vidi3D Pricing - Virtual Tour & 3D Visualization Packages" />
        <meta property="og:description" content="Find the perfect virtual tour package to elevate your venue sales. Flexible pricing options for vidi3D's immersive 3D visualization technology." />
        <meta property="og:type" content="website" />
        <meta property="og:image" content={`${process.env.PUBLIC_URL}/images/banner01.jpg`} />
        <link rel="canonical" href="https://vidi3d.com/pricing" />
      <div className="flex flex-col items-center w-full max-w-[1200px] p-4 mx-auto">
        <FadeIn>
        <h1 className="text-6xl font-bold text-brand text-center py-10">Transform Your Venue Sales with Immersive 3D Technology</h1>
        </FadeIn>
        <FadeIn delay={0.25}>
        <p className="text-brand-dark text-center text-xl mb-12">Select a plan that fits your needs and empower your sales team with our cutting-edge 3D visualization tools. Create immersive virtual experiences that captivate clients, accelerate decision-making, and give you a competitive edge in the market.</p>
        </FadeIn>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 w-full">
          {/* Starter Package */}
          <FadeIn delay={0.4}>
          <div className="border rounded-lg p-6 flex flex-col h-full">
            <h2 className="text-2xl font-bold text-brand mb-4">Starter Package</h2>
            <div className="mb-6">
              <h3 className="font-semibold mb-2">What's Included:</h3>
              <ul className="list-disc list-inside space-y-2">
                <li>Immersive 3D walkthrough</li>
                <li>Single room showcase</li>
                <li>Standard resolution</li>
                <li>Basic support</li>
              </ul>
            </div>
            <div className="mb-6">
              <h3 className="font-semibold mb-2">Add-ons Available:</h3>
              <ul className="list-disc list-inside space-y-2">
                <li>HD resolution upgrade</li>
                <li>Additional layout options</li>
              </ul>
            </div>
            <a href="/contact" className="mt-auto bg-brand text-white py-2 px-4 rounded hover:bg-brand-dark text-center">
              Get Starter
            </a>
          </div>
          </FadeIn>

          {/* Base Package */}
          <FadeIn delay={0.55}>
          <div className="border rounded-lg p-6 flex flex-col bg-gray-50 h-full">
            <h2 className="text-2xl font-bold text-brand mb-4">Base Package</h2>
            <div className="mb-6">
              <h3 className="font-semibold mb-2">What's Included:</h3>
              <ul className="list-disc list-inside space-y-2">
                <li>High-definition 3D experience</li>
                <li>Signature room showcase</li>
                <li>Up to 3 versatile layout options</li>
                <li>Stunning 360° panoramas</li>
                <li>Priority support access</li>
                <li>Performance analytics dashboard</li>
              </ul>
            </div>
            <div className="mb-6">
              <h3 className="font-semibold mb-2">Add-ons Available:</h3>
              <ul className="list-disc list-inside space-y-2">
                <li>Branded experience</li>
                <li>Enhanced analytics suite</li>
                <li>Extra layout designs</li>
              </ul>
            </div>
            <a href="/contact" className="mt-auto bg-brand text-white py-2 px-4 rounded hover:bg-brand-dark text-center">
              Get Base
            </a>
          </div>
          </FadeIn>

          {/* Premium Package */}
          <FadeIn delay={0.7}>
          <div className="border rounded-lg p-6 flex flex-col bg-brand text-white h-full">
            <h2 className="text-2xl font-bold mb-4">Premium Package</h2>
            <div className="mb-6">
              <h3 className="font-semibold mb-2">What's Included:</h3>
              <ul className="list-disc list-inside space-y-2">
                <li>4K walkthrough experience</li>
                <li>Dual room showcase</li>
                <li>Up to 5 stunning layout variations</li>
                <li>Interactive 360° exploration with hotspots</li>
                <li>24/7 VIP concierge support</li>
                <li>Comprehensive analytics suite</li>
                <li>Premium branded experience</li>
                <li>Immersive VR capabilities</li>
              </ul>
            </div>
            <div className="mb-6">
              <h3 className="font-semibold mb-2">Add-ons Available:</h3>
              <ul className="list-disc list-inside space-y-2">
                <li>Complete white-label solution</li>
                <li>API access</li>
                <li>Bespoke feature development</li>
              </ul>
            </div>
            <a href="/contact" className="mt-auto bg-white text-brand py-2 px-4 rounded hover:bg-gray-100 text-center">
              Get Premium
            </a>
          </div>
          </FadeIn>
        </div>
      </div>
      </>
    );
  }
  
  export default Pricing;